/**
 * AI Operation Types
 *
 * Categorizes AI generation operations for analytics and billing.
 * Used across AI module and Analytics module.
 */
export var AiOperationType;
(function (AiOperationType) {
    /** Text generation using Gemini models */
    AiOperationType["TEXT_GENERATION"] = "TEXT_GENERATION";
    /** Text generation with streaming response */
    AiOperationType["TEXT_GENERATION_STREAM"] = "TEXT_GENERATION_STREAM";
    /** Text generation with reasoning/thinking (Gemini 2.5+) */
    AiOperationType["TEXT_WITH_REASONING"] = "TEXT_WITH_REASONING";
    /** Image generation using Imagen models */
    AiOperationType["IMAGE_GENERATION"] = "IMAGE_GENERATION";
    /** Structured output generation with schema */
    AiOperationType["STRUCTURED_OUTPUT"] = "STRUCTURED_OUTPUT";
    /** Multimodal input processing (text + images) */
    AiOperationType["MULTIMODAL"] = "MULTIMODAL";
})(AiOperationType || (AiOperationType = {}));
//# sourceMappingURL=ai-operation-type.enum.js.map